import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const ModalFooter = (props)=>{
    const { className, ...rest } = props;
    const bsClass = classNames('modal-footer', className);
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        className: bsClass
    });
};
